import { Modal, Progress } from 'antd';
import { styled } from 'styled-components';

import { Response } from 'src/sdk';

import { ExportStatus, ResultToImages, useExport } from './export';

type ModalExportProps<K = any, T extends Object = any> = {
  open: boolean;
  api?: (args: K) => Response<T[]>;
  dataSource?: any[];
  args?: K;
  filename?: string;
  onClose: () => void;
  onFinish?: () => void;
  title?: string;
  total?: number;
  width?: number;
  resultToImages?: ResultToImages<T>;
};

function getTip(status: ExportStatus, error?: Error) {
  switch (status) {
    case ExportStatus.INIT:
      return `准备导出`;
    case ExportStatus.FETCHING:
      return '正在导出数据...';
    case ExportStatus.DOWNLOADING:
      return '正在下载图片...';
    case ExportStatus.ZIPPING:
      return '正在打包...';
    case ExportStatus.SUCCESS:
      return '导出成功';
    case ExportStatus.FAILURE:
      return error?.message || '导出失败';
  }
}

function getColor(status: ExportStatus) {
  switch (status) {
    case ExportStatus.FAILURE:
      return 'red';
    default:
      return;
  }
}

function getLoading(status: ExportStatus) {
  switch (status) {
    case ExportStatus.FETCHING:
    case ExportStatus.DOWNLOADING:
    case ExportStatus.ZIPPING:
      return true;
    default:
      return false;
  }
}

function getOkText(status: ExportStatus) {
  switch (status) {
    case ExportStatus.SUCCESS:
      return '完成';
    case ExportStatus.FAILURE:
      return '关闭';
    default:
      return '导出';
  }
}

export function ExportModal<K = any, T extends Object = any>(props: ModalExportProps) {
  const { open, api, dataSource, args, filename, onClose, onFinish, title, total, width, resultToImages } = props;
  const [{ progress, status, error }, callExport, resetExport] = useExport<K, T>(
    resultToImages,
    undefined,
    api,
    dataSource
  );

  const handleClose = () => onClose();
  const handleOk = () => {
    if (status === ExportStatus.INIT) {
      callExport(args, filename);
    }
    if (status === ExportStatus.SUCCESS || status === ExportStatus.FAILURE) {
      onFinish?.();
      onClose();
      resetExport();
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={handleOk}
      onCancel={handleClose}
      okText={getOkText(status)}
      confirmLoading={getLoading(status)}
      width={width}
      maskClosable={false}
      keyboard={false}
    >
      <Container>
        {total && <p>{`本次将导出 ${total} 条记录。`}</p>}
        <p style={{ color: getColor(status) }}>{getTip(status, error)}</p>
        <Progress
          percent={progress}
          status={status === ExportStatus.FAILURE ? 'exception' : 'active'}
          size={[450, 20]}
        />
      </Container>
    </Modal>
  );
}

const Container = styled.div`
  padding: 24px 0;
`;
